import { render } from "./CarrierId.vue?vue&type=template&id=793a256e&scoped=true&ts=true"
import script from "./CarrierId.vue?vue&type=script&lang=ts"
export * from "./CarrierId.vue?vue&type=script&lang=ts"

import "./CarrierId.vue?vue&type=style&index=0&id=793a256e&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793a256e"]])

export default __exports__